<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconDualScreen_16"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.09 3.94c0-.704.57-1.273 1.274-1.273h6.363c.703 0 1.273.57 1.273 1.272v4.455c0 .703-.57 1.273-1.273 1.273H10.8v-3.39a2 2 0 0 0-2-2H6.09v-.338ZM1 6.484c0-.703.57-1.273 1.273-1.273h6.363c.703 0 1.273.57 1.273 1.273v4.454c0 .703-.57 1.273-1.273 1.273H2.273C1.57 12.212 1 11.642 1 10.94V6.485Zm5.675 6.181H4.324l-.31.726c-.058.135.07.274.253.274h2.465c.183 0 .311-.139.254-.274l-.31-.726Z"
        fill="currentColor"
    />
</svg>
